
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"11","height":"23","viewBox":"0 0 11 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.273 1.045a1.045 1.045 0 10-2.09 0V19.43L1.787 17.03a1.045 1.045 0 00-1.707.34 1.047 1.047 0 00.227 1.14l4.18 4.18.016.014a1.04 1.04 0 001.463-.013l4.181-4.181a1.046 1.046 0 10-1.478-1.48l-2.396 2.398V1.045z","fill":"#000"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Lead/assets/arrow.svg
// module id = Jo80
// module chunks = 1